import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import router from './router'
import mitt from 'mitt'
import Unicon from 'vue-unicons'
import { createPinia } from 'pinia';
import { uniPhoneTimes, uniClockTen, uniCalendarAlt, uniUniversity, uniGraduationCap, uniMapMarkerAlt, uniMapMarker, uniStethoscope, uniUserCircle, uniPhone, uniMoneyBill, uniCommentInfo, uniImageResizeLandscape, uniScenery, uniSchedule,fileInfoAlt } from 'vue-unicons/dist/icons'

// Setup Unicons
Unicon.add([
  uniPhoneTimes, uniClockTen, uniCalendarAlt, uniUniversity, uniGraduationCap,
  uniMapMarkerAlt, uniMapMarker, uniStethoscope, uniUserCircle,
  uniPhone, uniMoneyBill, uniCommentInfo, uniImageResizeLandscape,
  uniScenery, uniSchedule,fileInfoAlt
])

const app = createApp(App);

// Global things first
const emitter = mitt();
app.config.globalProperties.emitter = emitter;

// Then other plugins
app.use(Unicon);
app.use(createPinia());
app.provide('emitter', emitter)
// Provide constants
app.provide('imgUrl', 'https://payhub.alifpay.com.my/');
app.provide('appUrl', 'https://payhub.alifpay.com.my');
app.provide('appDownloadUrl', 'http://onelink.to/pgyk4h');
app.provide('wallet_url','https://alifpaywalletapi.azurewebsites.net')

// Modal component
app.component("modalComponent", {
  template: "#modal-template"
});

// Finally router and mount
app.use(router);
app.mount('#app');
